import { apolloClient } from '@/apolloClient';
import { CheckPaymentEnrollmentDocument } from '@/types/vue-apollo-helpers';

interface EnrollmentCheckResult {
  enrolled: boolean;
  warnings: string[];
}

export const useCheckPaymentEnrollment = () => {
  const warnings = ref<string[]>([]);
  const enrolled = ref(true);
  const loading = ref(false);

  const check = async(studentId: string, billDetailIds: string[]) => {
    if (!studentId || billDetailIds.length === 0) {
      warnings.value = [];
      enrolled.value = true;
      return;
    }

    loading.value = true;
    try {
      const { data } = await apolloClient.query<{
        checkPaymentEnrollment: EnrollmentCheckResult;
      }>({
        query: CheckPaymentEnrollmentDocument,
        variables: { student_id: studentId, bill_detail_ids: billDetailIds },
        fetchPolicy: 'no-cache',
      });

      enrolled.value = data.checkPaymentEnrollment.enrolled;
      warnings.value = data.checkPaymentEnrollment.warnings;
    } catch {
      warnings.value = [];
      enrolled.value = true;
    } finally {
      loading.value = false;
    }
  };

  const clear = () => {
    warnings.value = [];
    enrolled.value = true;
  };

  return { warnings, enrolled, loading, check, clear };
};
